import React, { useContext, useRef, useEffect} from 'react';
import { ProductContext } from '../ProductContext';

const DetailsAccordion = ( props: { description: string; children: React.ReactNode }) => {
  const { isAccordionCollapsed, setFitAndDescriptionView } = useContext(ProductContext);
  const accordionRef = useRef<HTMLDivElement | null>(null);

  const handleClick = () => {
    setFitAndDescriptionView(false);
  };

  useEffect(() => {
    if(isAccordionCollapsed && accordionRef.current) {
      accordionRef.current.setAttribute("open", String(isAccordionCollapsed))
    }
  }, [isAccordionCollapsed])

  return (
    <details ref={accordionRef} onClick={handleClick}>
      <summary role="button">
        { props.description}
      </summary>
      {props.children}
    </details>
  );
};

export default DetailsAccordion;